import services from "@/http";
import * as types from "./mutation-types";

export const ActionGetAll = async ({ dispatch }, payload) => {
  let data = await dispatch("ActionFind", payload);
  dispatch("ActionSetAgendas", data.data);
  dispatch("ActionSetPagination", data.meta);
};

export const ActionGetAllItems = async ({ dispatch }, payload) => {
  const result = await dispatch("ActionFindItems", payload);
  dispatch("ActionSetItemsAgenda", result.data);
  dispatch("ActionSetPagination", result.meta);
};

export const ActionFind = async (store, search) => {
  var agendas = {
    data: [],
    meta: {},
  };

  await services.agendas.get_all(search).then((res) => {
    agendas = res.data;
  });
  return agendas;
};

export const ActionFindItems = async (store, search) => {
  try {
    const { data } = await services.agendas.get_all_items(search);
    return data;
  } catch (error) {
    return {
      data: [],
      meta: {},
    };
  }
};

export const ActionShow = async ({ dispatch }, id) => {
  await services.agendas.show({ id: id }).then((res) => {
    dispatch("ActionSetAgenda", res.data.agenda);
  });
};

export const ActionSave = async ({ dispatch }, payload) => {
  if (payload.id) {
    await dispatch("ActionUpdate", payload);
  } else {
    await dispatch("ActionStore", payload);
  }
};

export const ActionStore = async ({ commit }, payload) => {
  try {
    const { data } = await services.agendas.store(payload);
    commit(types.SET_AGENDA, data.agendas);
  } catch (error) {
    commit(types.SET_AGENDA, {});
  }
};

export const ActionUpdate = async ({ commit }, payload) => {
  await services.agendas.update({ id: payload.id }, payload).then((res) => {
    commit(types.SET_AGENDA, res.data.agenda);
  });
};

export const ActionDelete = async ({ commit }, id) => {
  await services.agendas.delete({ id: id }).then(() => {
    commit(types.SET_AGENDA, null);
  });
};

export const ActionSetAgendas = ({ commit }, payload) => {
  commit(types.SET_AGENDAS, payload);
};

export const ActionSetAgenda = ({ commit }, payload) => {
  commit(types.SET_AGENDA, payload);
};

export const ActionSetItemsAgenda = ({ commit }, payload) => {
  commit(types.SET_ITEMS_AGENDA, payload);
};

export const ActionSetPagination = ({ commit }, payload) => {
  commit(types.SET_PAGINATION, payload);
};

export const ActionSaveItemAgenda = async ({ dispatch }, payload) => {
  if (payload.id) {
    dispatch("ActionUpdateItemAgenda", payload);
  } else {
    dispatch("ActionStoreItemAgenda", payload);
  }
};

export const ActionStoreItemAgenda = async ({ commit }, payload) => {
  try {
    const { data } = await services.agendas.store_item(payload);
    commit(types.SET_ITEM_AGENDA, data);
    return data;
  } catch (error) {
    return {};
  }
};

export const ActionUpdateItemAgenda = async ({ commit }, payload) => {
  try {
    const { data } = await services.agendas.update_item(
      { id: payload.id },
      payload
    );
    commit(types.SET_ITEM_AGENDA, data);
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const ActionNewAgenda = ({ commit }) => {
  let agenda = {
    nome: "",
    sigla: "",
  };
  commit(types.SET_AGENDA, agenda);
};
